import { alphabeticalCompare } from 'shared'
import { CIMSColumn } from '../../CIMSColumn/types'
import { ColumnTitle } from 'antd/lib/table/interface'
import { SortOptions } from '../../CIMSColumn/types/sort'

interface UseNameColumnOptions<T> {
  /**
   * a customized title
   *
   * @default 'Name'
   */
  title?: ColumnTitle<T>
  /**
   * a custom {@link HelpMessage}
   */
  help: string
  /**
   * @see {@link SortOptions}
   */
  sort?: Pick<SortOptions<T>, 'default' | 'priority'>
  /**
   * set a custom width for the column
   * @default 255
   */
  width?: number | 'auto'
}

/**
 * A custom {@link UseNameColumnOptions.width|width} may be needed to resolve odd spacing
 */
export function useNameColumn<T extends { name?: string | null }>(
  options: UseNameColumnOptions<T>
): CIMSColumn<T> {
  return {
    title: options.title ?? 'Name',
    render: ({ name }) => name,
    sort: {
      ...options.sort,
      with: 'callback',
      onCompare: (a, b) => alphabeticalCompare(a.name, b.name),
    },
    filter: {
      type: 'search',
      with: 'callback',
      onFilter: (value, { name }) => {
        if (!name) return false
        return name.toLowerCase().includes(value.toString().toLowerCase())
      },
    },
    width: options.width ?? 255,
    help: options.help,
  }
}
